import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { BOOLEAN, DATE, DATE_TIME, ENUMERATION, NUMBER, STRING } from 'customer-data-objects/property/PropertyTypes';
import { Map as ImmutableMap, OrderedSet } from 'immutable';
const dateDefaults = OrderedSet.of(Operators.Less, Operators.Greater, Operators.InRange);
const TypeToOperators = ImmutableMap({
  [BOOLEAN]: OrderedSet.of(Operators.Equal, Operators.NotEqual),
  [DATE]: dateDefaults,
  [DATE_TIME]: dateDefaults,
  [ENUMERATION]: OrderedSet.of(Operators.Equal, Operators.In),
  [NUMBER]: OrderedSet.of(Operators.Equal, Operators.GreaterOrEqual, Operators.LessOrEqual, Operators.InRange),
  [STRING]: OrderedSet.of(Operators.Equal, Operators.In)
});
export const DataTypeToTypeToOperatorsOverrides = ImmutableMap({
  ANALYTICS_SOURCES: ImmutableMap({
    [ENUMERATION]: OrderedSet.of(Operators.Equal)
  }),
  UNIFIED_EVENTS_QL: ImmutableMap({
    [NUMBER]: OrderedSet.of(Operators.Equal, Operators.GreaterOrEqual, Operators.LessOrEqual, Operators.InRange, Operators.NotEqual, Operators.Less, Operators.Greater),
    [ENUMERATION]: OrderedSet.of(Operators.In, Operators.NotIn, Operators.Equal, Operators.NotEqual)
  })
});

// Note: when gating, use legacyOperators to restrict access to gated operators
// clean up your override once ungated
export const getOperatorsForTypeWithOverrides = reportingDataType => type => {
  if (!type) {
    return undefined;
  }
  const dataTypeBasedOverrides = reportingDataType && DataTypeToTypeToOperatorsOverrides.get(reportingDataType);
  const TypeToOperatorsWithOverrides = dataTypeBasedOverrides ? TypeToOperators.merge(dataTypeBasedOverrides) : TypeToOperators;
  return TypeToOperatorsWithOverrides.get(type);
};